import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from 'views/App/context';
import { useTemplateDetailsContext } from '../../../_shared/Details/context';
import TemplateOutlineCard from '../../../_shared/_components/TemplateOutlineCard';
import { translate as t } from 'hooks/useTranslations';
import { Template } from '../../../_shared/_types';

const TemplateOutline: React.FC = () => {
  const { currentOrganizationId, hasPermission } = useContext(AppContext);
  const { template, isLoading, isError, isDraft } = useTemplateDetailsContext();
  const navigate = useNavigate();

  const canManageTemplates = hasPermission('manageFieldBank', currentOrganizationId || '');

  const handleEditTemplate = () => {
    if (!template) return;
    // Agency Admin: Routes active templates to the viewer, draft templates to the builder
    if (!isDraft) {
      // Active templates go to the viewer
      navigate(`../../view/${template.id}`);
    } else {
      // Draft templates go to the builder
      navigate(`../../builder/${template.id}`);
    }
  };

  // Use "View Template" for active templates, "Edit Template" for drafts
  const actionLabel = isDraft
    ? t('performanceReporting.templates.details.actions.editTemplate')
    : t('performanceReporting.templates.list.actions.viewTemplate');

  if (!template) {
    return null;
  }

  return (
    <TemplateOutlineCard
      template={template}
      onEditClick={handleEditTemplate}
      actionLabel={actionLabel}
      canManage={canManageTemplates}
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export default TemplateOutline;

